import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class NotificationStore {
  private key = 'notifications_ribera';
  
  private subject = new BehaviorSubject<any>(this.read());
  notifications$ = this.subject.asObservable();

  private read() {
    return JSON.parse(localStorage.getItem(this.key) || 'null');
  }

  private write(data: any) {
    localStorage.setItem(this.key, JSON.stringify(data));
    this.subject.next(data);
  }

  get() {
    return this.read();
  }

  set(data: any) {
    this.write(data);
  }

  patch(patchFn: (current: any) => any) {
    const current = this.read();
    const updated = patchFn(current);
    this.write(updated);
  }

  clear() {
    localStorage.removeItem(this.key);
    this.subject.next(null);
  }
}